import React from "react"
import { categoriesFormatter, dateFormatter } from "../../../../../../helpers"
import { 
    StyledTabletOtherArticlesWrapper,
    StyledTabletOtherArticlesContainer,
    StyledOtherArticleAuthorImageContainer,
    StyledOtherArticleAuthorImage,
    StyledOtherArticleAuthorName,
    StyledOtherArticleCreationDate,
    StyledOtherArticleTitle,
    StyledOtherArticleCategory,
    StyledOtherArticleMotivationContainer,
    StyledOtherArticleMotivation,
    StyledSlash,
    StyledLink
} from "../../styled"
import useCategoryList from "../../../../../../hooks/use-category-list"

const TabletOtherArticles = ({ otherArticles }) => {
  const { getCategories } = useCategoryList()

  return (
    <>
      {otherArticles?.map(({ node }) => (
        <StyledTabletOtherArticlesWrapper>
          <StyledTabletOtherArticlesContainer>
            <StyledOtherArticleAuthorImageContainer>
              <StyledOtherArticleAuthorImage
                alt={node.author.avatar.name}
                src={node.author.avatar.formats.thumbnail.url}
              />
            </StyledOtherArticleAuthorImageContainer>
            <StyledOtherArticleAuthorName>
              {node.author.name}
            </StyledOtherArticleAuthorName>
            <StyledSlash>/</StyledSlash>
            <StyledOtherArticleCreationDate>
              {dateFormatter(node.date)}
            </StyledOtherArticleCreationDate>
          </StyledTabletOtherArticlesContainer>
          <StyledLink to={`/blog/${node.meta_url}`}>
            <StyledOtherArticleTitle>
              {node.title}
            </StyledOtherArticleTitle>
          </StyledLink>
          <StyledOtherArticleCategory>
            {getCategories(categoriesFormatter(node.categories))}
          </StyledOtherArticleCategory>
          <StyledOtherArticleMotivationContainer>
          <StyledOtherArticleMotivation>
            {node.exctract_content}
          </StyledOtherArticleMotivation>
          </StyledOtherArticleMotivationContainer>
        </StyledTabletOtherArticlesWrapper>
      ))}
    </>
  )
}

export default TabletOtherArticles
